











































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component({ name: "BaseSpinner" })
export default class BaseSpinner extends Vue {
  @Prop({ type: Number, default: 6 })
  public readonly strokeWidth!: number;

  @Prop({ type: Number })
  public readonly linePercentFill!: number | undefined;

  @Prop({ type: String })
  public color!: string;

  @Prop({ type: Number, default: 0 })
  public autoFillTimeout!: number;

  @Prop({ type: String, default: "35px" })
  public size!: string;

  @Prop({
    type: String,
    default: () =>
      Math.random()
        .toString(36)
        .substring(2, 15),
  })
  public id!: string;
}
